import { getFeatureAvailability } from './userinfoHelper';

export const TextInputs = {
  'idea-generation-workbook': {
    title: '30-Minute Content Ideas Worksheet',
    subTitle1: 'FREE 7 PAGE',
    subTitle2: 'CREATE AUDIO PRODUCTS THAT SELL',
    link: 'https://soundwiseinc.s3.amazonaws.com/files/Content_Ideas_Workbook_01.pdf',
  },
};

export const ucfirst = str => {
  return str.replace(/\w\S*/g, txt => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const encodeQuotes = str => {
  // The extra step will replace all the \" to " first
  // and then replace all the " back to \"
  // helpful when the result is from json.stringify
  return str
    .replace(/\\"/g, '"')
    .replace(/"/g, '\\"')
    .replace(/(\r\n|\n|\r|\t)/gm, '');
};

export const ALERTS = () => ({
  ADD_CATEGORY: {
    NO_ACCESS: `Adding category is available on ${getFeatureAvailability(
      'ADD_CATEGORY'
    )} plans. Please upgrade to access the feature.`,
  },
  EDIT_CATEGORY: {
    NO_ACCESS: `Editing soundcasts is available on ${getFeatureAvailability(
      'EDIT_CATEGORY'
    )} plans. Please upgrade to access the feature.`,
  },
  DELETE_CATEGORY: {
    NO_ACCESS: `Deleting category is available on ${getFeatureAvailability(
      'DELETE_CATEGORY'
    )} plans. Please upgrade to access the feature.`,
  },
  SET_AS_FEATURED_CATEGORY: {
    NO_ACCESS: `Setting as featured is available on ${getFeatureAvailability(
      'SET_AS_FEATURED_CATEGORY'
    )} plans. Please upgrade to access the feature.`,
  },
  UNSET_AS_FEATURED_CATEGORY: {
    NO_ACCESS: `Remove as featured is available on ${getFeatureAvailability(
      'UNSET_AS_FEATURED_CATEGORY'
    )} plans. Please upgrade to access the feature.`,
  },
  EDIT_CATEGORY_TITLE: {
    NO_ACCESS: `Editing category title is available on ${getFeatureAvailability(
      'EDIT_CATEGORY_TITLE'
    )} plans. Please upgrade to access the feature.`,
  },
  DND_CATEGORIES: {
    NO_ACCESS: `Changing category position is available on ${getFeatureAvailability(
      'DND_CATEGORIES'
    )} plans. Please upgrade to access the feature.`,
  },
  VIEW_ANALYTICS: {
    NO_ACCESS: `Listening analytics is available on ${getFeatureAvailability(
      'VIEW_ANALYTICS'
    )} plans. Please upgrade to access the feature.`,
  },
  VIEW_MESSAGES: {
    NO_ACCESS: `Sending messages to subscribers is available on ${getFeatureAvailability(
      'VIEW_MESSAGES'
    )} plans. Please upgrade to access the feature.`,
  },
  VIEW_SUBSCRIBERS: {
    NO_ACCESS: `Subscriber data is available on ${getFeatureAvailability(
      'VIEW_SUBSCRIBERS'
    )} plans. Please upgrade to access the feature.`,
  },
  EPISODE_DRIPPING: {
    NO_ACCESS: `Content dripping is only available on ${getFeatureAvailability(
      'EPISODE_DRIPPING'
    )} plans.`,
    EMPTY_EPISODES: 'Please make sure your soundcast has at least 1 track.',
    SCHEDULED: 'Track dripping schedule is saved',
    SAVING_ERROR:
      'There was a problem saving track dripping schedule. Please contact support at support@mysoundwise.com',
  },
  EPISODE_SCHEDULED: {
    NO_ACCESS: `Scheduled publishing is available on ${getFeatureAvailability(
      'EPISODE_SCHEDULED'
    )} plans.`,
  },
  EPISODE_PROCESSING: {
    NO_ACCESS: `Audio processing options are available on ${getFeatureAvailability(
      'EPISODE_PROCESSING'
    )} plans. Please upgrade to access this feature.`,
  },
  EPISODE_BULKUPLOAD: {
    NO_ACCESS: `Bulk upload is available on ${getFeatureAvailability(
      'EPISODE_BULKUPLOAD'
    )} plans. Please upgrade to access this feature.`,
    LIMIT_EXCEEDED:
      'You have exceeded the maximum limit on your current plan. Please upgrade to create more content.',
  },
  SOUNDCAST_INTRO_OUTRO: {
    NO_ACCESS: `Automatic insertion of intro and outro is available on ${getFeatureAvailability(
      'SOUNDCAST_INTRO_OUTRO'
    )} plans. Please upgrade to access this feature.`,
  },
  SOUNDCAST_INTRO_OUTRO_REPLACE: {
    NO_ACCESS: `Replace intro/outro on tracks that are already published is available on ${getFeatureAvailability(
      'SOUNDCAST_INTRO_OUTRO_REPLACE'
    )} plans. Please upgrade to access this feature.`,
  },
  NON_PAYMENT_ACCESS_LINK: {
    NO_ACCESS: `Signup form link is available on ${getFeatureAvailability(
      'NON_PAYMENT_ACCESS_LINK'
    )} plans. Please upgrade to access this feature.`,
  },
  SOUNDCAST_COUPONS: {
    NO_ACCESS: `Creating promo code is available on ${getFeatureAvailability(
      'SOUNDCAST_COUPONS'
    )} plans. Please upgrade to access this feature.`,
  },
  SOUNDCAST_COUPONS_100POFF: {
    NO_ACCESS: `Creating promo code with 100% discount is available on ${getFeatureAvailability(
      'SOUNDCAST_COUPONS_100POFF'
    )} plans. Please upgrade to access this feature.`,
  },
  SOUNDCAST_MULTIPLE_PRICING: {
    NO_ACCESS: `Adding multiple pricing options is available on ${getFeatureAvailability(
      'SOUNDCAST_MULTIPLE_PRICING'
    )} plans. Please upgrade to access this feature.`,
  },
  MAILCHIMP_INTEGRATION: {
    NO_ACCESS: 'Please upgrade your plan to integrate with Mailchimp.',
  },
  INTEGRATION_3RDPARTY_ZAPIER: {
    NO_ACCESS: `Soundwise API key for Zapier integration is available on ${getFeatureAvailability(
      'INTEGRATION_3RDPARTY_ZAPIER'
    )} plans. Please upgrade to get your own API key.`,
  },
  ALLOWED_ADMINS: {
    INVITE:
      'You have reached the maximum number of admins allowed in your plan. Upgrade for additional admins',
    SIGNUP: 'Publisher can no longer accept additional administrators.',
  },
  ALLOWED_YOUTUBE_CONNECT: {
    NO_ACCESS: 'Please upgrade your plan to convert your Youtube content.',
    LIMIT_EXCEEDED:
      'You have reached the maximum number of Youtube conversion in your plan. Please upgrade to convert more Youtube content.',
  },
  ALLOWED_PODCAST_FEEDS: {
    LIMIT_EXCEEDED:
      'You have reached the maximum number of podcast feeds in your plan. Please upgrade to create more feeds.',
  },
  ALLOWED_SOUNDCASTS: {
    LIMIT_EXCEEDED: 'Please upgrade to create more Soundcasts.',
  },
  ALLOWED_EPISODES: {
    LIMIT_EXCEEDED: 'Adding more Tracks is not available. Please upgrade to create more content.',
  },
});
